module.exports = __WEBPACK_EXTERNAL_MODULE__4785__;